// extracted by css-extract-rspack-plugin
export default {"table":"table-hxnu_0","rowHighlighted":"rowHighlighted-Kb8etf","discoveryTable":"discoveryTable-AhkIwo","reportTable":"reportTable-Ex6IGX"};